(() => {
  function initialiseSmartQuote(root) {
   
    if (!root || root.dataset.smartQuoteReady === 'true') {
      return;
    }

    const sectionId = root.dataset.sectionId;

    const dataElement = document.getElementById(
      `SmartQuoteData-${sectionId}`
    );

    let smartQuoteData = {
  collections: [],
  colours: [],
  prices: [],
  installationPrices: [],
  motors: {
    brands: [],
    powerTypes: [],
    models: [],
    remotes: [],
    chargers: []
  }
};

    if (dataElement) {
      try {
        const parsedData = JSON.parse(dataElement.textContent);

       smartQuoteData = {
  collections: Array.isArray(parsedData.collections)
    ? parsedData.collections
    : [],

  colours: Array.isArray(parsedData.colours)
    ? parsedData.colours
    : [],

    prices: Array.isArray(parsedData.prices)
  ? parsedData.prices
  : [],
  
    installationPrices: Array.isArray(parsedData.installationPrices)
    ? parsedData.installationPrices
    : [],

  motors: parsedData.motors || {
    brands: [],
    powerTypes: [],
    models: [],
    remotes: [],
    chargers: []
  }
};
      } catch (error) {
        console.error(
          'Quick Quote data could not be read.',
          error
        );
      }
    } else {
      console.warn(
        `Quick Quote data element was not found for section ${sectionId}.`
      );
    }
        fetch('/apps/smart-quote?data=prices')
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Smart Quote price data could not be loaded.'
          );
        }

        return response.json();
      })
      .then((result) => {
        if (Array.isArray(result?.prices)) {
          smartQuoteData.prices = result.prices;
        }
      })
      .catch((error) => {
        console.error(
          'Smart Quote price data could not be loaded.',
          error
        );
      });
    const form = root.querySelector('[data-smart-quote-form]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const progressItems = [
      ...root.querySelectorAll('[data-progress-step]')
    ];

    const backButton = root.querySelector(
      '[data-smart-quote-back]'
    );
    const nextButton = root.querySelector(
      '[data-smart-quote-next]'
    );
    const submitButton = root.querySelector(
      '[data-smart-quote-submit]'
    );

    const message = root.querySelector(
      '[data-smart-quote-message]'
    );
    const summary = root.querySelector(
      '[data-smart-quote-summary]'
    );

    const collectionSelect = form?.elements.collection;
    const colourSelect = form?.elements.colour;
    const motorBrandSelect = form?.elements.motor_brand;
const powerTypeSelect = form?.elements.power_type;
const remoteSelect = form?.elements.remote;
const chargerSelect = form?.elements.charger;
function resetMotorSelection() {
  if (motorBrandSelect) {
    motorBrandSelect.value = '';
  }

  if (powerTypeSelect) {
    powerTypeSelect.value = '';
  }

  if (remoteSelect) {
    remoteSelect.value = '';
  }

  if (chargerSelect) {
    chargerSelect.value = '';
  }

  if (form?.elements.motor_model) {
    form.elements.motor_model.value = '';
  }

  if (form?.elements.required_torque) {
    form.elements.required_torque.value = '';
  }

  if (form?.elements.calculated_area) {
    form.elements.calculated_area.value = '';
  }

  root
    .querySelectorAll(
      '[data-motor-brand-cards] .is-selected, ' +
      '[data-power-type-cards] .is-selected, ' +
      '[data-remote-cards] .is-selected, ' +
      '[data-charger-cards] .is-selected'
    )
    .forEach((card) => {
      card.classList.remove('is-selected');
    });

  const selectedMotorCard = root.querySelector(
    '[data-selected-motor-card]'
  );

  if (selectedMotorCard) {
    selectedMotorCard.innerHTML = '';
    selectedMotorCard.hidden = true;
  }
}

    const widthField = form?.elements.width;
    const dropField = form?.elements.drop;
    const runningTotal = root.querySelector(
  '[data-running-total]'
);

const runningTotalValue = root.querySelector(
  '[data-running-total-value]'
);
const addedToQuoteConfirmation = root.querySelector(
  '[data-added-to-quote]'
);

const viewQuoteButton = root.querySelector(
  '[data-view-quote]'
);
const quoteView = root.querySelector(
  '[data-quote-view]'
);
const persistentQuote = root.querySelector(
  '[data-persistent-quote]'
);

const persistentQuoteCount = root.querySelector(
  '[data-persistent-quote-count]'
);

const persistentQuoteTotal = root.querySelector(
  '[data-persistent-quote-total]'
);
const persistentViewQuoteButton = root.querySelector(
  '[data-persistent-view-quote]'
);
const returnToCurrentItemButton = root.querySelector(
  '[data-return-to-current-item]'
);
const quoteProgress = root.querySelector(
  '[data-quote-progress]'
);
const smartQuoteActions = root.querySelector(
  '[data-smart-quote-actions]'
);
const addAnotherFromQuoteButton = root.querySelector(
  '[data-add-another-from-quote]'
);

const quoteItemCount = root.querySelector(
  '[data-quote-item-count]'
);

const finalQuoteMessage = root.querySelector(
  '[data-final-quote-message]'
);
const quoteSubmitSuccess = root.querySelector(
  '[data-quote-submit-success]'
);
const customerFirstName = root.querySelector(
  '[name="first_name"]'
);

const customerLastName = root.querySelector(
  '[name="last_name"]'
);

const customerPhone = root.querySelector(
  '[name="phone"]'
);

const customerEmail = root.querySelector(
  '[name="email"]'
);

const customerAddress = root.querySelector(
  '[name="address"]'
);
const customerSuburb = root.querySelector(
  '[name="suburb"]'
);

const customerPostcode = root.querySelector(
  '[name="postcode"]'
);
const quoteEmailForm = root.querySelector(
  '#SmartQuoteEmailForm'
);
const finalQuoteSubmitButton = root.querySelector(
  '[data-submit-final-quote]'
);

const quoteEmailName = root.querySelector(
  '[data-quote-email-name]'
);

const quoteEmailEmail = root.querySelector(
  '[data-quote-email-email]'
);

const quoteEmailPhone = root.querySelector(
  '[data-quote-email-phone]'
);

const quoteEmailAddress = root.querySelector(
  '[data-quote-email-address]'
);

const quoteEmailPostcode = root.querySelector(
  '[data-quote-email-postcode]'
);

const quoteEmailTotal = root.querySelector(
  '[data-quote-email-total]'
);

const quoteEmailDetails = root.querySelector(
  '[data-quote-email-details]'
);

const addAnotherFromConfirmationButton = root.querySelector(
  '[data-add-another-from-confirmation]'
);


const copyBlindChoice = root.querySelector(
  '[data-copy-blind-choice]'
);

const copyPreviousBlindButton = root.querySelector(
  '[data-copy-previous-blind]'
);

const startNewBlindButton = root.querySelector(
  '[data-start-new-blind]'
);
const blindList = root.querySelector(
  '[data-blind-list]'
);

const blindListItems = root.querySelector(
  '[data-blind-list-items]'
);
const quoteTotal = root.querySelector(
  '[data-quote-total]'
);
    const freeMeasureButton = root.querySelector(
  '[data-request-free-measure]'
);

    const widthError = root.querySelector('[data-width-error]');
    const dropError = root.querySelector('[data-drop-error]');

    const chainOptions = root.querySelector(
      '[data-chain-options]'
    );
    const motorOptions = root.querySelector(
      '[data-motor-options]'
    );
    const chargerField = root.querySelector(
      '[data-charger-field]'
    );

 if (
  !form ||
  !steps.length ||
  !backButton ||
  !nextButton ||
  !submitButton
) {
  console.warn(
    'Quick Quote could not start because required elements are missing.'
  );

  return;
}
    
   
    root.dataset.smartQuoteReady = 'true';
    fetch('/apps/smart-quote?data=colours')
  .then((response) => {
    if (!response.ok) {
      throw new Error(
        'Smart Quote colour data could not be loaded.'
      );
    }

    return response.json();
  })
  .then((result) => {
    if (!Array.isArray(result?.colours)) {
      return;
    }

    const selectedCollectionHandle =
      collectionSelect?.value || '';

    const selectedColourHandle =
      colourSelect?.value || '';

    smartQuoteData.colours = result.colours;

    if (selectedCollectionHandle) {
      populateColours(selectedCollectionHandle);

      if (selectedColourHandle && colourSelect) {
        colourSelect.value = selectedColourHandle;

        const colourCards =
          form.querySelector('[data-colour-cards]');

        colourCards
          ?.querySelectorAll('[data-colour-handle]')
          .forEach((card) => {
            const isSelected =
              card.dataset.colourHandle ===
              selectedColourHandle;

            card.classList.toggle(
              'is-selected',
              isSelected
            );

            card.setAttribute(
              'aria-pressed',
              isSelected ? 'true' : 'false'
            );
          });
      }
    }
  })
  .catch((error) => {
    console.error(
      'Smart Quote colour data could not be loaded.',
      error
    );
  });

   let currentStep = 1;
let highestReachedStep = 1;

const totalSteps = steps.length;
let quoteItems = [];
let activeItemId = null;
let currentDraftSnapshot = null;
let isFinalQuoteSubmitting = false;
let currentSubmissionId = null;
let currentQuoteId = null;
let currentDraftStep = null;
let isChoosingAnotherItem = false;
let nextItemId = 1;

function captureCurrentBlind() {
  const formData = new FormData(form);

  const values = {};

  for (const [key, value] of formData.entries()) {
    values[key] = value;
  }
  if (widthField) {
  values.width = widthField.value;
}

if (dropField) {
  values.drop = dropField.value;
}

if (form.elements.room_name) {
  values.room_name =
    form.elements.room_name.value;
}

  const basePriceModel = findBasePrice();

  const selectedMotorModel =
    form.elements.motor_model?.value || '';

  const motorPriceModel =
    smartQuoteData.motors.models.find((model) => {
      return (
        model.name === selectedMotorModel ||
        model.handle === selectedMotorModel
      );
    });

  const selectedRemote =
    form.elements.remote?.value || '';

  const remotePriceModel =
    smartQuoteData.motors.remotes.find((remote) => {
      return (
        remote.handle === selectedRemote ||
        remote.name === selectedRemote
      );
    });

  const selectedCharger =
    form.elements.charger?.value || '';

  const chargerPriceModel =
    smartQuoteData.motors.chargers.find((charger) => {
      return (
        charger.handle === selectedCharger ||
        charger.name === selectedCharger
      );
    });

  const selectedInstallation =
    form.elements.installation?.value || '';

  const selectedOperationType =
    form.elements.operation_type?.value || '';

  let installationPriceModel = null;

  if (
    selectedInstallation ===
      'supply-installation' &&
    selectedOperationType
  ) {
    installationPriceModel =
      smartQuoteData.installationPrices.find((item) => {
        return (
          item.operationType ===
          selectedOperationType
        );
      });
  }

  const basePrice =
    Number(basePriceModel?.sellingPrice) || 0;

  const motorPrice =
    Number(motorPriceModel?.sellingPrice) || 0;

  const remotePrice =
    Number(remotePriceModel?.sellingPrice) || 0;

  const chargerPrice =
    Number(chargerPriceModel?.sellingPrice) || 0;

  const installationPrice =
    Number(
      installationPriceModel?.sellingPrice
    ) || 0;

  const itemSubtotal =
    basePrice +
    motorPrice +
    remotePrice +
    chargerPrice +
    installationPrice;

  const itemTotalIncGst =
  priceIncGst(itemSubtotal);

const collectionName =
  collectionSelect?.selectedOptions?.[0]?.textContent?.trim() || '';

const colourName =
  colourSelect?.selectedOptions?.[0]?.textContent?.trim() || '';

return {
  id: activeItemId,
  values,

  roomName:
    form.elements.room_name?.value || '',

  collectionName,
  colourName,

  basePrice,
  motorPrice,
  remotePrice,
  chargerPrice,
  installationPrice,
  itemSubtotal,
  gstRate: 0.10,
  itemTotalIncGst
};
}
function buildCustomerFacingItemDetails(item) {
  const values = item?.values || {};
  const details = [];

  const addDetail = (label, value) => {
    const cleanValue = String(value || '').trim();

    if (!cleanValue) {
      return;
    }

    details.push({
      label,
      value: cleanValue
    });
  };

  addDetail(
    'Product',
    values.blind_type
      ? `${formatLabel(values.blind_type)} Roller Blind`
      : ''
  );

  addDetail(
    'Collection',
    item.collectionName ||
      formatLabel(values.collection || '')
  );

  addDetail(
    'Colour',
    item.colourName ||
      formatLabel(values.colour || '')
  );
if (values.width && values.drop) {
  addDetail(
    'Measurement',
    `W ${values.width} mm × H ${values.drop} mm`
  );
}

addDetail(
  'Location',
  values.room_name || item.roomName || ''
);

addDetail(
  'Operation',
  formatLabel(values.operation_type || '')
);

  if (values.operation_type === 'chain') {
    addDetail(
      'Chain Colour',
      formatLabel(values.chain_colour || '')
    );
  }

  if (values.operation_type === 'motorised') {
    addDetail(
      'Motor Brand',
      formatLabel(values.motor_brand || '')
    );

    addDetail(
      'Power Type',
      formatLabel(values.power_type || '')
    );

       addDetail(
      'Remote',
      formatLabel(values.remote || '')
    );

    addDetail(
      'Charger',
      formatLabel(values.charger || '')
    );
  }

  addDetail(
    'Control Side',
    formatLabel(values.control_side || '')
  );

  addDetail(
    'Fitting Type',
    formatLabel(values.fitting_type || '')
  );

  addDetail(
    'Roll Direction',
    formatLabel(values.roll_direction || '')
  );

  addDetail(
    'Bracket Colour',
    formatLabel(values.bracket_colour || '')
  );

  const bottomRail = [
    formatLabel(values.bottom_rail_shape || ''),
    formatLabel(values.bottom_rail_colour || '')
  ]
    .filter(Boolean)
    .join(' · ');

  addDetail(
    'Bottom Rail',
    bottomRail
  );

  const installationValue =
    values.installation || '';

  addDetail(
    'Installation',
    installationValue === 'supply-installation'
      ? 'Supply & Installation'
      : installationValue === 'supply-only'
        ? 'Supply Only'
        : formatLabel(installationValue)
  );

  addDetail(
    'Item Total',
    formatDisplayPrice(
      item.itemTotalIncGst
    )
  );

  return details;
}
function renderBlindList() {
  if (!blindList || !blindListItems) {
    return;
  }

 if (quoteItemCount) {
  quoteItemCount.textContent =
    String(quoteItems.length);
}

const total = quoteItems.reduce(
  (sum, item) => {
    return sum +
      Number(item.itemTotalIncGst || 0);
  },
  0
);

if (quoteTotal) {
  quoteTotal.textContent =
    formatDisplayPrice(total);
}

if (!quoteItems.length) {
  blindList.hidden = true;
  blindListItems.innerHTML = '';
  return;
}

  blindList.hidden = false;

  blindListItems.innerHTML = quoteItems
    .map((item, index) => {
     
    const title = `Blind ${index + 1}`;
        const values = item.values || {};

const blindType =
  formatLabel(values.blind_type || '');

const collection =
  item.collectionName ||
  formatLabel(values.collection || '');

const colour =
  item.colourName ||
  formatLabel(values.colour || '');

const width =
  values.width || '';

const drop =
  values.drop || '';

const operation =
  formatLabel(values.operation_type || '');
const installationValue =
  values.installation || '';

const installation =
  installationValue === 'supply-installation'
    ? 'Supply & Installation'
    : installationValue === 'supply-only'
      ? 'Supply Only'
      : formatLabel(installationValue);

      const motorBrand =
  formatLabel(values.motor_brand || '');

const powerType =
  formatLabel(values.power_type || '');

        return `
        <div
  class="smart-quote__blind-list-item"
  data-blind-item-id="${item.id}"
>
  <div class="smart-quote__blind-list-item-main">
    <div>
      <strong class="smart-quote__blind-title">
        ${title}
      </strong>

      ${
        blindType
          ? `<div class="smart-quote__blind-product">
              ${blindType} Roller Blind
            </div>`
          : ''
      }
    </div>

    <strong class="smart-quote__blind-price">
      ${formatDisplayPrice(
        item.itemTotalIncGst
      )}
    </strong>
  </div>

  <div class="smart-quote__blind-list-item-details">

    ${
      collection || colour
        ? `<div>
            <span>Fabric:</span>
            <strong>
              ${[collection, colour]
                .filter(Boolean)
                .join(' · ')}
            </strong>
          </div>`
        : ''
    }

    ${
      width && drop
        ? `<div>
            <span>Measurement:</span>
            <strong>
              W ${width} mm × H ${drop} mm
            </strong>
          </div>`
        : ''
    }

    ${
      operation
        ? `<div>
            <span>Operation:</span>
            <strong>${operation}</strong>
          </div>`
        : ''
    }

    ${
      values.operation_type === 'motorised' &&
      (motorBrand || powerType)
        ? `<div>
            <span>Motor:</span>
            <strong>
              ${[
                motorBrand,
                powerType
              ]
                .filter(Boolean)
                .join(' · ')}
            </strong>
          </div>`
        : ''
    }

    ${
      installation
        ? `<div>
            <span>Installation:</span>
            <strong>${installation}</strong>
          </div>`
        : ''
    }

  </div>

  <div
    class="smart-quote__blind-item-details-panel"
    data-blind-details-panel="${item.id}"
    hidden
  ></div>

  <div class="smart-quote__blind-list-item-actions">
    <button
      type="button"
      class="smart-quote__blind-edit"
      data-edit-blind="${item.id}"
    >
      Edit
    </button>

    <button
      type="button"
      class="smart-quote__blind-details"
      data-view-blind-details="${item.id}"
    >
      View Details
    </button>

    <button
      type="button"
      class="smart-quote__blind-remove"
      data-remove-blind="${item.id}"
    >
      Remove
    </button>
  </div>
</div>
`;

      })
    .join('');
    blindListItems
    .querySelectorAll('[data-edit-blind]')
    .forEach((button) => {
      button.addEventListener('click', () => {
        const itemId =
          button.dataset.editBlind;

        const item = quoteItems.find(
          (quoteItem) =>
            quoteItem.id === itemId
        );

if (!item) {
  return;
}

currentDraftSnapshot = null;
currentDraftStep = null;
isChoosingAnotherItem = false;

if (returnToCurrentItemButton) {
  returnToCurrentItemButton.hidden = true;
}

        if (quoteView) {
  quoteView.hidden = true;
}

if (form) {
  form.hidden = false;
}

if (copyBlindChoice) {
  copyBlindChoice.hidden = true;
}

if (quoteProgress) {
  quoteProgress.hidden = false;
}

if (smartQuoteActions) {
  smartQuoteActions.hidden = false;
}


if (addedToQuoteConfirmation) {
  addedToQuoteConfirmation.hidden = true;
}

if (submitButton) {
  submitButton.textContent = 'Update Item';
}
        restoreBlindItem(item);

        highestReachedStep = totalSteps;
        showStep(1);
      });
    }); 
    blindListItems
  .querySelectorAll('[data-view-blind-details]')
  .forEach((button) => {
    button.addEventListener('click', () => {
      const itemId =
        button.dataset.viewBlindDetails;

      const item = quoteItems.find(
        (quoteItem) =>
          quoteItem.id === itemId
      );

      if (!item) {
        return;
      }

      const panel = blindListItems.querySelector(
        `[data-blind-details-panel="${itemId}"]`
      );

      if (!panel) {
        return;
      }

      const isOpening = panel.hidden;

      blindListItems
        .querySelectorAll('[data-blind-details-panel]')
        .forEach((detailsPanel) => {
          detailsPanel.hidden = true;
        });
        blindListItems
  .querySelectorAll('[data-view-blind-details]')
  .forEach((detailsButton) => {
    detailsButton.textContent = 'View Details';
  });

      if (!isOpening) {
        button.textContent = 'View Details';
        return;
      }

      const details =
        buildCustomerFacingItemDetails(item);

      panel.innerHTML = details
        .map((detail) => {
          return `
            <div class="smart-quote__detail-row">
              <span>${detail.label}</span>
              <strong>${detail.value}</strong>
            </div>
          `;
        })
        .join('');

      panel.hidden = false;
      button.textContent = 'Hide Details';
    });
  });
    blindListItems
  .querySelectorAll('[data-remove-blind]')
  .forEach((button) => {
   button.addEventListener('click', () => {
  const itemId =
    button.dataset.removeBlind;

  currentDraftSnapshot = null;
  currentDraftStep = null;

  if (returnToCurrentItemButton) {
    returnToCurrentItemButton.hidden = true;
  }

  quoteItems = quoteItems.filter(
    (item) => item.id !== itemId
  );

  if (activeItemId === itemId) {
    activeItemId = null;
  }

renderBlindList();
updatePersistentQuoteControl();
    });
  });

}

function saveCurrentBlind() {
  const snapshot = captureCurrentBlind();

  if (!snapshot.id) {
    snapshot.id = `blind-${nextItemId}`;
    activeItemId = snapshot.id;
    nextItemId += 1;
  }

  const existingIndex = quoteItems.findIndex(
    (item) => item.id === snapshot.id
  );

  if (existingIndex >= 0) {
    quoteItems[existingIndex] = snapshot;
  } else {
    quoteItems.push(snapshot);
  }
  updatePersistentQuoteControl();



  return snapshot;
}
function restoreBlindItem(item) {
  if (!item || !item.values) {
    return;
  }

  activeItemId = item.id || null;

  const values = item.values;

  function setRadioValue(name, value) {
    if (!value) {
      return;
    }

    const radio = form.querySelector(
      `input[type="radio"][name="${name}"][value="${value}"]`
    );

    if (!radio) {
      return;
    }

    radio.checked = true;

    radio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function setSelectValue(select, value) {
    if (!select || !value) {
      return;
    }

    select.value = value;

    select.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }
    function restoreVisualSelection(
  containerSelector,
  datasetKey,
  value
) {
  const container =
    root.querySelector(containerSelector);

  if (!container) {
    return;
  }

  const cards = [
    ...container.querySelectorAll(
      '.smart-quote__visual-card'
    )
  ];

  cards.forEach((card) => {
    card.classList.remove('is-selected');
  });

  if (!value) {
    return;
  }

  const selectedCard = cards.find((card) => {
    return card.dataset[datasetKey] === value;
  });

  selectedCard?.classList.add('is-selected');
}


  /* Step 1 — Blind Type */
  setRadioValue(
    'blind_type',
    values.blind_type
  );

  /* Step 2 — Collection */
  if (values.collection) {
    setSelectValue(
      collectionSelect,
      values.collection
    );

    const collectionCard = root.querySelector(
      `[data-collection-handle="${values.collection}"]`
    );

    if (collectionCard) {
      root
        .querySelectorAll(
          '[data-collection-cards] .smart-quote__image-card'
        )
        .forEach((card) => {
          card.classList.remove('is-selected');
          card.setAttribute(
            'aria-pressed',
            'false'
          );
        });

      collectionCard.classList.add(
        'is-selected'
      );

      collectionCard.setAttribute(
        'aria-pressed',
        'true'
      );
    }
  }

  /* Step 2 — Colour */
  if (values.colour) {
    setSelectValue(
      colourSelect,
      values.colour
    );

    const colourCard = root.querySelector(
      `[data-colour-handle="${values.colour}"]`
    );

    if (colourCard) {
      root
        .querySelectorAll(
          '[data-colour-cards] .smart-quote__image-card'
        )
        .forEach((card) => {
          card.classList.remove('is-selected');
          card.setAttribute(
            'aria-pressed',
            'false'
          );
        });

      colourCard.classList.add(
        'is-selected'
      );

      colourCard.setAttribute(
        'aria-pressed',
        'true'
      );
    }
  }

  /* Step 3 — Room + Measurements */
  if (form.elements.room_name) {
    form.elements.room_name.value =
      values.room_name || '';
  }

  if (widthField) {
    widthField.value =
      values.width || '';
  }

  if (dropField) {
    dropField.value =
      values.drop || '';
  }

  updateMotorisedAvailability();
  /* Step 4 — Operation */
  setRadioValue(
    'operation_type',
    values.operation_type
  );

  /* Chain */
  if (values.operation_type === 'chain') {
    setRadioValue(
      'chain_colour',
      values.chain_colour
    );
  }

  /* Motor */
   if (values.operation_type === 'motorised') {
     const motorBrandCard = root.querySelector(
      `[data-motor-brand-handle="${values.motor_brand}"]`
     );

  if (motorBrandCard) {
    motorBrandCard.click();
  } else {
    setSelectValue(
      motorBrandSelect,
      values.motor_brand
    );
  }

  setSelectValue(
    powerTypeSelect,
    values.power_type
  );

    if (values.remote !== undefined) {
      remoteSelect.value =
        values.remote || '';

      remoteSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }

    if (
      chargerSelect &&
      values.charger !== undefined
    ) {
      chargerSelect.value =
        values.charger || '';

      chargerSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
    restoreVisualSelection(
  '[data-motor-brand-cards]',
  'motorBrandHandle',
  values.motor_brand
);

restoreVisualSelection(
  '[data-power-type-cards]',
  'powerTypeHandle',
  values.power_type
);

restoreVisualSelection(
  '[data-remote-cards]',
  'remoteHandle',
  values.remote
);

restoreVisualSelection(
  '[data-charger-cards]',
  'chargerHandle',
  values.charger
);
  }

  /* Installation */
  setRadioValue(
    'installation',
    values.installation
  );

  /* Step 5 — Product Options */
  setRadioValue(
    'control_side',
    values.control_side
  );

  setRadioValue(
    'fitting_type',
    values.fitting_type
  );

  setRadioValue(
    'roll_direction',
    values.roll_direction
  );

  setRadioValue(
    'bracket_colour',
    values.bracket_colour
  );

  setRadioValue(
    'bottom_rail_shape',
    values.bottom_rail_shape
  );

  setRadioValue(
    'bottom_rail_colour',
    values.bottom_rail_colour
  );
  /* Final restore — measurements after dependent change events */
if (form.elements.room_name) {
  form.elements.room_name.value =
    values.room_name || '';
}

if (widthField) {
  widthField.value =
    values.width || '';
}

if (dropField) {
  dropField.value =
    values.drop || '';
}

  updateRunningTotal();

}
    function setMessage(text = '') {
      if (message) {
        message.textContent = text;
      }
    }

    function formatDisplayPrice(value) {
  const amount = Number(value) || 0;

  return `$${amount.toFixed(2)}`;
}
function updatePersistentQuoteControl() {
  if (
    !persistentQuote ||
    !persistentQuoteCount ||
    !persistentQuoteTotal
  ) {
    return;
  }

  if (!quoteItems.length) {
    persistentQuote.hidden = true;
    return;
  }

  const total = quoteItems.reduce(
  (sum, item) => {
    return sum +
      Number(item.itemTotalIncGst || 0);
  },
  0
);

  persistentQuoteCount.textContent =
    `${quoteItems.length} ${
      quoteItems.length === 1 ? 'item' : 'items'
    }`;

  persistentQuoteTotal.textContent =
    formatDisplayPrice(total);

  persistentQuote.hidden = false;
}
    function formatLabel(value) {
      return String(value)
        .replaceAll('-', ' ')
        .replaceAll('_', ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
    }

    function priceIncGst(exGstPrice) {
  const price = Number(exGstPrice) || 0;

  return price * 1.10;
}
    function normaliseValue(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replaceAll('_', '-')
        .replace(/\s+/g, '-');
    }

    function getNumber(value) {
      if (
        value === undefined ||
        value === null ||
        String(value).trim() === ''
      ) {
        return null;
      }

      const number = Number(value);

      return Number.isFinite(number) ? number : null;
    }

    function clearFieldError(field, errorElement) {
      if (field) {
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      }

      if (errorElement) {
        errorElement.textContent = '';
        errorElement.hidden = true;
      }
    }

    function showFieldError(field, errorElement, text) {
      if (!field) {
        return;
      }

      field.setCustomValidity(text);
      field.setAttribute('aria-invalid', 'true');

      if (errorElement) {
        errorElement.textContent = text;
        errorElement.hidden = false;
      }
    }

    function validateMeasurementField(
      field,
      errorElement,
      fieldLabel
    ) {
      if (!field || field.disabled || field.closest('[hidden]')) {
        return true;
      }

      clearFieldError(field, errorElement);

      const rawValue = String(field.value).trim();

      if (!rawValue) {
        if (field.required) {
          showFieldError(
            field,
            errorElement,
            `Please enter the ${fieldLabel.toLowerCase()}.`
          );

          return false;
        }

        return true;
      }
     const value = getNumber(rawValue);
     const minimum = getNumber(field.min);
     const maximum = getNumber(field.max);

     if (value === null) {
       showFieldError(
         field,
         errorElement,
         `Please enter a valid ${fieldLabel.toLowerCase()}.`
       );

       return false;
     }

     if (value <= 0) {
        showFieldError(
          field,
           errorElement,
            `${fieldLabel} must be greater than 0 mm.`
         );

       return false;
     } 

     if (minimum !== null && value < minimum) {
       showFieldError(
        field,
         errorElement,
        `${fieldLabel} must be at least ${minimum} mm.`
      );

      return false;
    }

      if (maximum !== null && value > maximum) {
        showFieldError(
          field,
          errorElement,
          `${fieldLabel} must not exceed ${maximum} mm.`
        );

        return false;
      }

      return true;
    }

    function validateMeasurements() {
      const widthIsValid = validateMeasurementField(
        widthField,
        widthError,
        'Width'
      );

      const dropIsValid = validateMeasurementField(
        dropField,
        dropError,
        'Drop'
      );

      return widthIsValid && dropIsValid;
    }

    function showStep(stepNumber) {
      currentStep = Math.min(
        Math.max(stepNumber, 1),
        totalSteps
      );
      highestReachedStep = Math.max(
  highestReachedStep,
  currentStep
);

        steps.forEach((step) => {
        const stepValue = Number(step.dataset.step);
        const isCurrent = stepValue === currentStep;

        step.hidden = !isCurrent;
        step.classList.toggle('is-active', isCurrent);
      });

     progressItems.forEach((item) => {
  const progressStep = Number(
    item.dataset.progressStep
  );

  const isCurrent =
    progressStep === currentStep;

  const isReached =
    progressStep <= highestReachedStep;

  const isComplete =
    progressStep < currentStep ||
    (
      progressStep < highestReachedStep &&
      progressStep !== currentStep
    );

  const isFuture =
    progressStep > highestReachedStep;

  item.classList.toggle(
    'is-active',
    isCurrent
  );

  item.classList.toggle(
    'is-complete',
    isComplete
  );

  item.classList.toggle(
    'is-reached',
    isReached
  );

  item.classList.toggle(
    'is-future',
    isFuture
  );
});

      backButton.hidden = currentStep === 1;
nextButton.hidden = currentStep === totalSteps;
submitButton.hidden = currentStep !== totalSteps;

backButton.style.display =
  currentStep === 1 ? 'none' : '';

nextButton.style.display =
  currentStep === totalSteps ? 'none' : '';

submitButton.style.display =
  currentStep === totalSteps ? '' : 'none';
 
  
  if (runningTotal) {
  if (currentStep < 3 || currentStep === totalSteps) {
    runningTotal.hidden = true;
  } else {
    updateRunningTotal();
  }
}
      if (currentStep === totalSteps) {
  buildSummary();
}
if (copyBlindChoice) {
  copyBlindChoice.hidden =
    !isChoosingAnotherItem;
}
if (isChoosingAnotherItem) {
  backButton.hidden = true;
  nextButton.hidden = true;
  submitButton.hidden = true;

  backButton.style.display = 'none';
  nextButton.style.display = 'none';
  submitButton.style.display = 'none';

  if (smartQuoteActions) {
    smartQuoteActions.hidden = true;
  }
} else {
  if (smartQuoteActions) {
    smartQuoteActions.hidden = false;
  }
}
updatePersistentQuoteControl();

      setMessage();

      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    function validateCurrentStep() {
      const currentStepElement = root.querySelector(
        `[data-step="${currentStep}"]`
      );

      if (!currentStepElement) {
        return true;
      }

      if (
        currentStep === 3 &&
        !validateMeasurements()
      ) {
        setMessage(
          'Please correct the measurements before continuing.'
        );

        const firstInvalidField =
          currentStepElement.querySelector(
            '[aria-invalid="true"]'
          );

        firstInvalidField?.focus();

        return false;
      }

      if (currentStep === 4) {
  const selectedOperation =
    form.querySelector(
      'input[name="operation_type"]:checked'
    );

  if (!selectedOperation) {
    setMessage(
      'Please select Chain or Motorised before continuing.'
    );

    const firstAvailableOperation =
      currentStepElement.querySelector(
        'input[name="operation_type"]:not(:disabled)'
      );

    firstAvailableOperation?.focus();

    return false;
  }
  if (selectedOperation.value === 'motorised') {
  const motorBrand =
    String(form.elements.motor_brand?.value || '').trim();

  const powerType =
    String(form.elements.power_type?.value || '').trim();

  const remote =
    String(form.elements.remote?.value || '').trim();

  const charger =
    String(form.elements.charger?.value || '').trim();

  if (!motorBrand) {
    setMessage(
      'Please select a motor brand before continuing.'
    );
    return false;
  }

  if (!powerType) {
    setMessage(
      'Please select a power type before continuing.'
    );
    return false;
  }

  if (!remote) {
    setMessage(
      'Please select a remote option before continuing.'
    );
    return false;
  }

  const isBattery =
    powerType.toLowerCase().includes('battery');

  if (isBattery && !charger) {
    setMessage(
      'Please select a charger option before continuing.'
    );
    return false;
  }
 }
}

      const requiredFields = [
        ...currentStepElement.querySelectorAll('[required]')
      ];

      const checkedRadioNames = new Set();

      for (const field of requiredFields) {
        if (field.disabled || field.closest('[hidden]')) {
          continue;
        }

        if (field.type === 'radio') {
          if (checkedRadioNames.has(field.name)) {
            continue;
          }

          checkedRadioNames.add(field.name);

          const selectedRadio =
            currentStepElement.querySelector(
              `input[type="radio"][name="${field.name}"]:checked`
            );

          if (!selectedRadio) {
            setMessage(
              'Please make a selection before continuing.'
            );

            field.focus();

            return false;
          }

          continue;
        }

        if (!String(field.value).trim()) {
          setMessage(
            'Please complete the required fields before continuing.'
          );

          field.focus();

          return false;
        }

        if (!field.checkValidity()) {
          setMessage(
            field.validationMessage ||
              'Please check the information entered before continuing.'
          );

          field.focus();

          return false;
        }
      }

      return true;
    }

    function resetSelect(select, placeholder) {
      if (!select) {
        return;
      }

      select.innerHTML = '';

      const option = document.createElement('option');

      option.value = '';
      option.textContent = placeholder;

      select.appendChild(option);
    }

    function blindTypeMatches(collectionBlindType, selectedType) {
      const collectionType = normaliseValue(
        collectionBlindType
      );
      const selected = normaliseValue(selectedType);

      if (!collectionType || !selected) {
        return false;
      }

      if (collectionType === selected) {
        return true;
      }

      if (
        selected === 'light-filter' &&
        (
          collectionType.includes('light-filter') ||
          collectionType.includes('light-filtering')
        )
      ) {
        return true;
      }

      if (
        selected === 'blockout' &&
        collectionType.includes('blockout')
      ) {
        return true;
      }

      if (
        selected === 'sunscreen' &&
        collectionType.includes('sunscreen')
      ) {
        return true;
      }

      return false;
    }

function openTextureLightbox(
  imageSrc,
  imageAlt = '',
  selectLabel = '',
  onSelect = null
) {
  if (!imageSrc) {
    return;
  }

  const existingLightbox =
    document.querySelector('.smart-quote__texture-lightbox');

  if (existingLightbox) {
    existingLightbox.remove();
  }

  const lightbox = document.createElement('div');
  lightbox.className =
    'smart-quote__texture-lightbox';

  const content = document.createElement('div');
  content.className =
    'smart-quote__texture-lightbox-content';

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className =
    'smart-quote__texture-lightbox-close';
  closeButton.setAttribute(
    'aria-label',
    'Close image'
  );
  closeButton.innerHTML = '&times;';

  const image = document.createElement('img');
  image.src = imageSrc;
  image.alt = imageAlt;

  const actions = document.createElement('div');
  actions.className =
    'smart-quote__texture-lightbox-actions';

  const cancelButton = document.createElement('button');
  cancelButton.type = 'button';
  cancelButton.className =
    'smart-quote__texture-lightbox-cancel';
  cancelButton.textContent = 'Close';

  actions.appendChild(cancelButton);

  if (
    selectLabel &&
    typeof onSelect === 'function'
  ) {
    const selectButton =
      document.createElement('button');

    selectButton.type = 'button';
    selectButton.className =
      'smart-quote__texture-lightbox-select';

    selectButton.textContent = selectLabel;

    actions.appendChild(selectButton);

    selectButton.addEventListener('click', () => {
      onSelect();
      closeLightbox();
    });
  }

  content.appendChild(closeButton);
  content.appendChild(image);
  content.appendChild(actions);

  lightbox.appendChild(content);
  document.body.appendChild(lightbox);

  function closeLightbox() {
    lightbox.remove();

    document.removeEventListener(
      'keydown',
      handleEscape
    );
  }

  function handleEscape(event) {
    if (event.key === 'Escape') {
      closeLightbox();
    }
  }

  closeButton.addEventListener(
    'click',
    closeLightbox
  );

  cancelButton.addEventListener(
    'click',
    closeLightbox
  );

  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  document.addEventListener(
    'keydown',
    handleEscape
  );
}

function getCollectionFromPrice(collection) {
  if (!collection?.priceGroup) {
    return null;
  }

  const validPrices = smartQuoteData.prices
    .filter((price) => {
      return price.priceGroup === collection.priceGroup;
    })
    .map((price) => Number(price.sellingPrice))
    .filter((price) => {
      return Number.isFinite(price) && price > 0;
    });

  if (!validPrices.length) {
    return null;
  }

  return Math.min(...validPrices);
}
   function populateCollections(blindType) {
  resetSelect(
    collectionSelect,
    'Select a collection'
  );

  resetSelect(
    colourSelect,
    'Select a colour'
  );

  const collectionCards =
    form.querySelector('[data-collection-cards]');

  if (collectionCards) {
    collectionCards.innerHTML = '';
  }

  const collectionField =
  collectionCards?.closest(
    '.smart-quote__field'
  );

const stepTwo =
  collectionCards?.closest(
    '[data-step="2"]'
  );

function collapseCollections(
  selectedCollectionHandle
) {
  if (!collectionCards) {
    return;
  }

  collectionCards
    .querySelectorAll(
      '.smart-quote__image-card'
    )
    .forEach((item) => {
      item.hidden =
        item.dataset.collectionHandle !==
        selectedCollectionHandle;
    });

  collectionCards.classList.add(
    'is-collapsed'
  );

  stepTwo?.classList.add(
    'has-selected-collection'
  );

  let changeButton =
    collectionField?.querySelector(
      '[data-change-collection]'
    );

  if (!changeButton && collectionField) {
    changeButton =
      document.createElement('button');

    changeButton.type = 'button';

    changeButton.className =
      'smart-quote__change-collection';

    changeButton.dataset.changeCollection = '';

    changeButton.textContent =
      'Change Collection';

    collectionCards.insertAdjacentElement(
      'afterend',
      changeButton
    );

    changeButton.addEventListener(
      'click',
      () => {
        collectionCards
          .querySelectorAll(
            '.smart-quote__image-card'
          )
          .forEach((item) => {
            item.hidden = false;

            item.classList.remove(
              'is-selected'
            );

            item.setAttribute(
              'aria-pressed',
              'false'
            );
          });

        collectionCards.classList.remove(
          'is-collapsed'
        );

        stepTwo?.classList.remove(
          'has-selected-collection'
        );

        collectionSelect.value = '';

        resetSelect(
          colourSelect,
          'Select a colour'
        );

        const colourCards =
          form.querySelector(
            '[data-colour-cards]'
          );

        if (colourCards) {
          colourCards.innerHTML = '';
        }

        changeButton.hidden = true;
      }
    );
  }

  if (changeButton) {
    changeButton.hidden = false;
  }
}
  const matchingCollections =
    smartQuoteData.collections
      .filter((collection) => {
        return blindTypeMatches(
          collection.blindType,
          blindType
        );
      })
      .sort((a, b) => {
        const orderA = Number(a.sortOrder) || 999;
        const orderB = Number(b.sortOrder) || 999;

        return orderA - orderB;
      });

  matchingCollections.forEach((collection) => {
    const option = document.createElement('option');

    option.value = collection.handle;
    option.textContent =
      collection.name || collection.handle;

    option.dataset.collectionCode =
      collection.code || '';

    collectionSelect?.appendChild(option);

    if (collectionCards) {
      const card = document.createElement('button');

      card.type = 'button';
      card.className = 'smart-quote__image-card';

      card.dataset.collectionHandle =
        collection.handle;

      card.setAttribute(
        'aria-pressed',
        'false'
      );

      if (collection.image) {
  const image = document.createElement('img');

  image.src = collection.image;
  image.alt =
    collection.name || 'Blind collection';

  image.loading = 'lazy';
  image.classList.add('smart-quote__texture-image');

  image.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();

  openTextureLightbox(
    collection.image,
    collection.name || 'Blind collection',
    'Select Collection',
    () => {
      if (!collectionSelect) {
        return;
      }

      collectionSelect.value = collection.handle;

      collectionCards
        .querySelectorAll('.smart-quote__image-card')
        .forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');

      collectionSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
      collapseCollections(
  collection.handle
);
    }
  );
});
  card.appendChild(image);
}

      const label = document.createElement('span');

      label.className =
        'smart-quote__image-card-label';

      label.textContent =
        collection.name || collection.handle;

      card.appendChild(label);
      const fromPrice =
  getCollectionFromPrice(collection);

if (fromPrice !== null) {
  const priceLabel =
    document.createElement('span');

  priceLabel.className =
    'smart-quote__image-card-price';

 const customerFromPrice =
  priceIncGst(fromPrice);

priceLabel.textContent =
  `From ${formatDisplayPrice(customerFromPrice)}`;
  card.appendChild(priceLabel);
}

      card.addEventListener('click', () => {
        if (!collectionSelect) {
          return;
        }

        collectionSelect.value =
          collection.handle;

        collectionCards
          .querySelectorAll(
            '.smart-quote__image-card'
          )
          .forEach((item) => {
            item.classList.remove(
              'is-selected'
            );

            item.setAttribute(
              'aria-pressed',
              'false'
            );
          });

        card.classList.add('is-selected');

        card.setAttribute(
          'aria-pressed',
          'true'
        );

        collectionSelect.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
        collapseCollections(
  collection.handle
);
      });

      collectionCards.appendChild(card);
    }
  });

  if (!matchingCollections.length) {
    console.warn(
      'No Smart Quote collections matched the selected blind type.',
      {
        selectedBlindType: blindType,
        availableCollections:
          smartQuoteData.collections
      }
    );
  }
}

function populateColours(collectionHandle) {
  resetSelect(
    colourSelect,
    'Select a colour'
  );

  const colourCards =
    form.querySelector('[data-colour-cards]');

  if (colourCards) {
    colourCards.innerHTML = '';
  }

  if (!collectionHandle) {
    return;
  }

  const matchingColours =
    smartQuoteData.colours
      .filter((colour) => {
        const relatedCollections = Array.isArray(
          colour.collections
        )
          ? colour.collections
          : [];

        return relatedCollections.includes(
          collectionHandle
        );
      })
      .sort((a, b) => {
        const orderA = Number(a.sortOrder) || 999;
        const orderB = Number(b.sortOrder) || 999;

        return orderA - orderB;
      });

  matchingColours.forEach((colour) => {
    // Keep native select for existing validation / summary logic
    const option = document.createElement('option');

    option.value = colour.handle;
    option.textContent =
      colour.name || colour.handle;

    option.dataset.colourCode =
      colour.code || '';

    colourSelect?.appendChild(option);

    // Build visual colour card
    if (colourCards) {
      const card = document.createElement('button');

      card.type = 'button';
      card.className =
        'smart-quote__image-card smart-quote__colour-card';

      card.dataset.colourHandle =
        colour.handle;

      card.setAttribute(
        'aria-pressed',
        'false'
      );

     if (colour.swatch) {
  const image = document.createElement('img');

  image.src = colour.swatch;
  image.alt =
    colour.name || 'Blind colour';

  image.loading = 'lazy';
  image.classList.add('smart-quote__texture-image');


  card.appendChild(image);
}

      const label = document.createElement('span');

      label.className =
        'smart-quote__image-card-label';

      label.textContent =
        colour.name || colour.handle;

      card.appendChild(label);

      card.addEventListener('click', (event) => {
  const clickedImage =
    event.target.closest?.('.smart-quote__texture-image');

  if (clickedImage && colour.swatch) {
    event.preventDefault();
    event.stopPropagation();

   openTextureLightbox(
  colour.swatch,
  colour.name || 'Blind colour',
  'Select Colour',
  () => {
    if (!colourSelect) {
      return;
    }

    colourSelect.value = colour.handle;

    colourCards
      .querySelectorAll('.smart-quote__image-card')
      .forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });

    card.classList.add('is-selected');
    card.setAttribute('aria-pressed', 'true');

    colourSelect.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }
);
    return;
  }

  if (!colourSelect) {
    return;
  }

  colourSelect.value = colour.handle;

  colourCards
    .querySelectorAll('.smart-quote__image-card')
    .forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute(
        'aria-pressed',
        'false'
      );
    });

  card.classList.add('is-selected');
  card.setAttribute(
    'aria-pressed',
    'true'
  );

  colourSelect.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
});
      colourCards.appendChild(card);
    }
  });

  if (!matchingColours.length) {
    console.warn(
      'No Smart Quote colours matched the selected collection.',
      {
        selectedCollection: collectionHandle,
        availableColours:
          smartQuoteData.colours
      }
    );
  }
}

    function updateInstallationPrice() {
  const priceElement = form.querySelector(
    '[data-installation-price]'
  );

  if (!priceElement) return;

  const selectedOperationType =
    form.elements.operation_type?.value || '';

  if (!selectedOperationType) {
    priceElement.textContent = '';
    priceElement.hidden = true;
    return;
  }

  const installationPrices =
  Array.isArray(smartQuoteData.installationPrices)
    ? smartQuoteData.installationPrices
    : [];

const installationPriceModel =
  installationPrices.find((item) => {
    return item.operationType === selectedOperationType;
  });

  const installationPrice = Number(
    installationPriceModel?.sellingPrice || 0
  );

  if (installationPrice > 0) {
  priceElement.textContent =
  `+${formatDisplayPrice(
    priceIncGst(installationPrice)
  )}`;
    priceElement.hidden = false;
  } else {
    priceElement.textContent = '';
    priceElement.hidden = true;
  }
}
function updateMotorisedAvailability() {
  const width = Number(widthField?.value);

  const motorisedInput = form.querySelector(
    'input[name="operation_type"][value="motorised"]'
  );

  const motorisedCard =
    motorisedInput?.closest(
      '.smart-quote__option-card'
    );

  if (!motorisedInput || !motorisedCard) {
    return;
  }
 
  const motorisedAllowed =
    Number.isFinite(width) &&
    width >= 550;

  motorisedCard.hidden = !motorisedAllowed;
  motorisedInput.disabled = !motorisedAllowed;

  if (
    !motorisedAllowed &&
    motorisedInput.checked
  ) {
    motorisedInput.checked = false;

    updateOperationType('');
    resetMotorSelection();

    updateRunningTotal();
  }
}
      function updateOperationType(value) {
  const isChain = value === 'chain';
  const isMotorised = value === 'motorised';

 if (chainOptions) {
  chainOptions.hidden = !isChain;

  chainOptions
    .querySelectorAll(
      'select, input[type="radio"]'
    )
    .forEach((field) => {
      field.required = isChain;
      field.disabled = !isChain;
    });
}

  if (motorOptions) {
    motorOptions.hidden = !isMotorised;

    motorOptions
      .querySelectorAll('select')
      .forEach((field) => {
        const isOptionalAccessory =
          field.name === 'remote' ||
          field.name === 'charger';

        field.required =
          isMotorised && !isOptionalAccessory;

        field.disabled = !isMotorised;
      });
  }

  if (form?.elements.remote) {
    form.elements.remote.required = false;
  }

  if (form?.elements.charger) {
    form.elements.charger.required = false;
  }

  if (!isMotorised && chargerField) {
    chargerField.hidden = true;
  }
  }

    function updatePowerType(value) {
  if (!chargerField) {
    return;
  }

  const isBattery = value === 'battery';

  chargerField.hidden = !isBattery;

  chargerField
    .querySelectorAll('select')
    .forEach((field) => {
      field.required = false;
      field.disabled = !isBattery;
    });
}
function findBasePrice() {
  const collectionHandle = form.elements.collection?.value || '';
  const width = Number(form.elements.width?.value) || 0;
  const drop = Number(form.elements.drop?.value) || 0;

  if (!collectionHandle || !width || !drop) {
    return null;
  }

  const selectedCollection = smartQuoteData.collections.find(
    (collection) => collection.handle === collectionHandle
  );

  if (!selectedCollection?.priceGroup) {
    return null;
  }

  const priceGroup = selectedCollection.priceGroup;

  const groupPrices = smartQuoteData.prices.filter(
  (price) => price.priceGroup === priceGroup
);
const nextWidth = groupPrices
  .map((price) => Number(price.widthUpTo))
  .filter((value) => value >= width)
  .sort((a, b) => a - b)[0];
const nextDrop = groupPrices
  .map((price) => Number(price.heightUpTo))
  .filter((value) => value >= drop)
  .sort((a, b) => a - b)[0];



if (!nextWidth || !nextDrop) {
  return null;
}

return (
  groupPrices.find((price) => {
    return (
      Number(price.widthUpTo) === nextWidth &&
      Number(price.heightUpTo) === nextDrop
    );
  }) || null
);
}

function updateRunningTotal() {
  if (!runningTotal || !runningTotalValue) {
    return;
  }

  const basePrice = findBasePrice();

  if (
    !basePrice ||
    !Number(basePrice.sellingPrice)
  ) {
    runningTotal.hidden = true;
    runningTotalValue.textContent = '$0.00';
    return;
  }

  let total =
    Number(basePrice.sellingPrice) || 0;

  const selectedOperationType =
    form.elements.operation_type?.value || '';

  if (selectedOperationType === 'motorised') {
    const selectedMotorModel =
      form.elements.motor_model?.value || '';

    const motorPriceModel =
      smartQuoteData.motors.models.find((model) => {
        return (
          model.name === selectedMotorModel ||
          model.handle === selectedMotorModel
        );
      });

    if (motorPriceModel) {
      total +=
        Number(motorPriceModel.sellingPrice) || 0;
    }

    const selectedRemote =
      form.elements.remote?.value || '';

    const remotePriceModel =
      smartQuoteData.motors.remotes.find((remote) => {
        return (
          remote.handle === selectedRemote ||
          remote.name === selectedRemote
        );
      });

    if (remotePriceModel) {
      total +=
        Number(remotePriceModel.sellingPrice) || 0;
    }

    const selectedCharger =
      form.elements.charger?.value || '';

    const chargerPriceModel =
      smartQuoteData.motors.chargers.find((charger) => {
        return (
          charger.handle === selectedCharger ||
          charger.name === selectedCharger
        );
      });

    if (chargerPriceModel) {
      total +=
        Number(chargerPriceModel.sellingPrice) || 0;
    }
  }

  const selectedInstallation =
    form.elements.installation?.value || '';

  if (
    selectedInstallation === 'supply-installation' &&
    selectedOperationType
  ) {
    const installationPriceModel =
      smartQuoteData.installationPrices.find((item) => {
        return (
          item.operationType ===
          selectedOperationType
        );
      });

    if (installationPriceModel) {
      total +=
        Number(
          installationPriceModel.sellingPrice
        ) || 0;
    }
  }

const customerTotal =
  priceIncGst(total);

runningTotalValue.textContent =
  formatDisplayPrice(customerTotal);

  runningTotal.hidden = false;
}

function buildSummary() {
  if (!summary) {
    return;
  }

  function getFieldValue(name) {
    const field = form.elements[name];

    if (!field) {
      return '';
    }

    if (field instanceof RadioNodeList) {
      return field.value || '';
    }

    return field.value || '';
  }

  function getDisplayValue(name) {
    const field = form.elements[name];

    if (!field) {
      return '';
    }

    const value = getFieldValue(name);

    if (!value) {
      return '';
    }

    if (
      field instanceof HTMLSelectElement &&
      field.selectedOptions.length
    ) {
      return field.selectedOptions[0].textContent.trim();
    }

    return formatLabel(value);
  }

  function addRow(label, value, extraClass = '') {
    if (!String(value || '').trim()) {
      return;
    }

    rows.push(`
      <div class="smart-quote__summary-row ${extraClass}">
        <span>${label}</span>
        <strong>${value}</strong>
      </div>
    `);
  }

  const rows = [];

  /* -------------------------
     Product / Fabric
  ------------------------- */

  addRow(
    'Blind Type',
    getDisplayValue('blind_type')
  );

  addRow(
    'Collection',
    getDisplayValue('collection')
  );

  addRow(
    'Colour',
    getDisplayValue('colour')
  );

  /* -------------------------
     Location / Measurement
  ------------------------- */

  const roomName =
    String(getFieldValue('room_name')).trim();

  if (roomName) {
    addRow('Room Name', roomName);
  }

  const width =
    String(getFieldValue('width')).trim();

  const drop =
    String(getFieldValue('drop')).trim();

  if (width && drop) {
    addRow(
  'Measurement',
  `W ${width} mm × H ${drop} mm`
);
  }

  /* -------------------------
     Operation
  ------------------------- */

  const operationType =
    getFieldValue('operation_type');

  addRow(
    'Operation',
    getDisplayValue('operation_type')
  );

  if (operationType === 'chain') {
    addRow(
      'Chain Colour',
      getDisplayValue('chain_colour')
    );
  }

  if (operationType === 'motorised') {
    addRow(
      'Motor Brand',
      getDisplayValue('motor_brand')
    );

    addRow(
      'Power Type',
      getDisplayValue('power_type')
    );

   
    addRow(
      'Remote',
      getDisplayValue('remote')
    );

    addRow(
      'Charger',
      getDisplayValue('charger')
    );
  }

  /* -------------------------
     Product Options
  ------------------------- */

  addRow(
    'Control Side',
    getDisplayValue('control_side')
  );

  addRow(
    'Fitting Type',
    getDisplayValue('fitting_type')
  );

  addRow(
    'Roll Direction',
    getDisplayValue('roll_direction')
  );

  addRow(
    'Bracket Colour',
    getDisplayValue('bracket_colour')
  );

  const bottomRailShape =
    getDisplayValue('bottom_rail_shape');

  const bottomRailColour =
    getDisplayValue('bottom_rail_colour');

  if (bottomRailShape || bottomRailColour) {
    addRow(
      'Bottom Rail',
      [
        bottomRailShape,
        bottomRailColour
      ]
        .filter(Boolean)
        .join(' — ')
    );
  }

  addRow(
    'Installation',
    getDisplayValue('installation')
  );

  /* -------------------------
     Pricing
  ------------------------- */

  const basePrice = findBasePrice();

  const selectedMotorModel =
    getFieldValue('motor_model');

  const motorPriceModel =
    smartQuoteData.motors.models.find((model) => {
      return (
        model.name === selectedMotorModel ||
        model.handle === selectedMotorModel
      );
    });

  const selectedRemote =
    getFieldValue('remote');

  const remotePriceModel =
    smartQuoteData.motors.remotes.find((remote) => {
      return (
        remote.handle === selectedRemote ||
        remote.name === selectedRemote
      );
    });

  const selectedCharger =
    getFieldValue('charger');

  const chargerPriceModel =
    smartQuoteData.motors.chargers.find((charger) => {
      return (
        charger.handle === selectedCharger ||
        charger.name === selectedCharger
      );
    });

  const selectedInstallation =
    getFieldValue('installation');

  let installationPriceModel = null;

  if (
    selectedInstallation === 'supply-installation' &&
    operationType
  ) {
    installationPriceModel =
      smartQuoteData.installationPrices.find((item) => {
        return item.operationType === operationType;
      });
  }

  let subtotal = 0;

  const basePriceValue =
    Number(basePrice?.sellingPrice) || 0;

  const motorPriceValue =
    Number(motorPriceModel?.sellingPrice) || 0;

  const remotePriceValue =
    Number(remotePriceModel?.sellingPrice) || 0;

  const chargerPriceValue =
    Number(chargerPriceModel?.sellingPrice) || 0;

  const installationPriceValue =
    Number(
      installationPriceModel?.sellingPrice
    ) || 0;

  subtotal += basePriceValue;
  subtotal += motorPriceValue;
  subtotal += remotePriceValue;
  subtotal += chargerPriceValue;
  subtotal += installationPriceValue;

  rows.push(`
    <div class="smart-quote__summary-heading">
      <strong>Price Summary</strong>
    </div>
  `);

  addRow(
    'Base Blind',
  formatDisplayPrice(
  priceIncGst(basePriceValue)
)
  );

  if (motorPriceValue > 0) {
    addRow(
      'Motor',
     formatDisplayPrice(
  priceIncGst(motorPriceValue)
)
    );
  }

  if (remotePriceValue > 0) {
    addRow(
      'Remote',
     formatDisplayPrice(
  priceIncGst(remotePriceValue)
)
    );
  }

  if (chargerPriceValue > 0) {
    addRow(
      'Charger',
      formatDisplayPrice(
  priceIncGst(chargerPriceValue)
)
    );
  }

 if (installationPriceValue > 0) {
  addRow(
    'Installation',
    formatDisplayPrice(
      priceIncGst(installationPriceValue)
    )
  );
}

  addRow(
    'Blind Total',
  formatDisplayPrice(
  priceIncGst(subtotal)
 ),
    'smart-quote__summary-row--total'
  );

  summary.innerHTML = rows.join('');
}

if (persistentViewQuoteButton) {
  persistentViewQuoteButton.addEventListener('click', () => {
    currentDraftSnapshot =
      captureCurrentBlind();
     
    currentDraftStep =
      currentStep;
      if (returnToCurrentItemButton) {
  returnToCurrentItemButton.hidden = false;
}

    if (form) {
      form.hidden = true;
    }

    if (quoteProgress) {
      quoteProgress.hidden = true;
    }

    if (persistentQuote) {
      persistentQuote.hidden = true;
    }

    if (quoteView) {
      quoteView.hidden = false;
    }

    renderBlindList();

    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
}
if (returnToCurrentItemButton) {
  returnToCurrentItemButton.addEventListener('click', () => {
    if (!currentDraftSnapshot) {
      return;
    }
    isChoosingAnotherItem = false;

    if (quoteView) {
      quoteView.hidden = true;
    }

    if (form) {
      form.hidden = false;
    }

    if (quoteProgress) {
      quoteProgress.hidden = false;
    }

    if (smartQuoteActions) {
      smartQuoteActions.hidden = false;
    }
   
if (copyBlindChoice) {
  copyBlindChoice.hidden = true;
}

    restoreBlindItem(currentDraftSnapshot);

    const stepToRestore =
      currentDraftStep || 1;

    showStep(stepToRestore);

    currentDraftSnapshot = null;
    currentDraftStep = null;

    returnToCurrentItemButton.hidden = true;

    updatePersistentQuoteControl();
  });
}
if (viewQuoteButton) {
  viewQuoteButton.addEventListener('click', () => {

    if (form) {
      form.hidden = true;
    }

    if (quoteProgress) {
      quoteProgress.hidden = true;
    }

    if (quoteView) {
      quoteView.hidden = false;
    }

    renderBlindList();

    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
}
if (addAnotherFromQuoteButton) {
  addAnotherFromQuoteButton.addEventListener('click', () => {
    isChoosingAnotherItem = true;
    activeItemId = null;

    if (quoteView) {
      quoteView.hidden = true;
    }

    if (form) {
      form.hidden = false;
    }

    if (quoteProgress) {
      quoteProgress.hidden = false;
    }

  if (submitButton) {
  submitButton.textContent = 'Add to Quote';
}

    if (addedToQuoteConfirmation) {
      addedToQuoteConfirmation.hidden = true;
    }
    
    
    showStep(currentStep);
    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
}
if (addAnotherFromConfirmationButton) {
  addAnotherFromConfirmationButton.addEventListener('click', () => {
    isChoosingAnotherItem = true;
activeItemId = null;
    if (addedToQuoteConfirmation) {
      addedToQuoteConfirmation.hidden = true;
    }
    if (smartQuoteActions) {
  smartQuoteActions.hidden = false;
}
if (submitButton) {
  submitButton.textContent = 'Add to Quote';
}
   
    if (copyBlindChoice) {
      copyBlindChoice.hidden = false;
    }

     });
}
if (copyPreviousBlindButton) {
  copyPreviousBlindButton.addEventListener('click', () => {
      isChoosingAnotherItem = false;
    const previousBlind =
      quoteItems[quoteItems.length - 1];

    if (!previousBlind) {
      return;
    }
   
    const copiedBlind = {
      ...previousBlind,
      id: null,
      values: {
  ...previousBlind.values,

  },
      roomName: '',

      basePrice: 0,
      motorPrice: 0,
      remotePrice: 0,
      chargerPrice: 0,
      installationPrice: 0,
      itemSubtotal: 0
    };

    activeItemId = null;
   
    restoreBlindItem(copiedBlind);

    if (form.elements.room_name) {
      form.elements.room_name.value = '';
    }

    if (widthField) {
      widthField.value = '';
    }

    updateMotorisedAvailability();

    if (dropField) {
      dropField.value = '';
    }

    if (runningTotal) {
      runningTotal.hidden = true;
    }

    if (runningTotalValue) {
      runningTotalValue.textContent = '$0.00';
    }

      if (copyBlindChoice) {
  copyBlindChoice.hidden = true;
}

 
    highestReachedStep = Math.max(
      highestReachedStep,
      3
    );

    showStep(3);
  });
}
if (startNewBlindButton) {
  startNewBlindButton.addEventListener('click', () => {
    isChoosingAnotherItem = false;
    activeItemId = null;

    form.reset();
    resetMotorSelection();
    updateOperationType('');
    updateMotorisedAvailability();
   
    resetSelect(
      collectionSelect,
      'Select a collection'
    );

    resetSelect(
      colourSelect,
      'Select a colour'
    );

    const collectionCards =
      form.querySelector('[data-collection-cards]');

    if (collectionCards) {
      collectionCards.innerHTML = '';
    }

    const colourCards =
      form.querySelector('[data-colour-cards]');

    if (colourCards) {
      colourCards.innerHTML = '';
    }

    if (runningTotal) {
      runningTotal.hidden = true;
    }

    if (runningTotalValue) {
      runningTotalValue.textContent = '$0.00';
    }

    if (copyBlindChoice) {
      copyBlindChoice.hidden = true;
    }

    highestReachedStep = 1;

    showStep(1);
  });
}
if (freeMeasureButton) {
  freeMeasureButton.addEventListener('click', () => {
    if (widthField) {
      widthField.required = false;
      clearFieldError(widthField, widthError);
    }

    if (dropField) {
      dropField.required = false;
      clearFieldError(dropField, dropError);
    }

    const selectedBlindType =
      form.querySelector(
        'input[name="blind_type"]:checked'
      )?.value || '';

    const collectionName =
      collectionSelect?.selectedOptions?.[0]?.textContent?.trim() || '';

    const colourName =
      colourSelect?.selectedOptions?.[0]?.textContent?.trim() || '';

    const freeMeasureContext = {
      requestType: 'Free Measure & Quote',
      productType: root.dataset.productType || 'roller-blind',
      blindType: selectedBlindType
        ? formatLabel(selectedBlindType)
        : '',
      collection: collectionName,
      colour: colourName
    };

    sessionStorage.setItem(
      'fancyFrameFreeMeasureContext',
      JSON.stringify(freeMeasureContext)
    );

    const consultationLink = [
      ...document.querySelectorAll('a[href]')
    ].find((link) => {
      const text = String(
        link.textContent || ''
      )
        .trim()
        .toLowerCase();

      return (
        text.includes('free consultation') ||
        text.includes('free measure')
      );
    });

    if (!consultationLink) {
      setMessage(
        'The Free Consultation page could not be found.'
      );
      return;
    }

    const destination = new URL(
      consultationLink.href,
      window.location.origin
    );

    destination.searchParams.set(
      'free_measure',
      '1'
    );

    window.location.href = destination.toString();
  });
}
   nextButton.addEventListener('click', () => {
if (!validateCurrentStep()) {
  return;
}
if (currentStep === 3) {
  updateMotorisedAvailability();
}

if (
  currentStep === 3 &&
  Number(widthField?.value) < 670
) {
  const selectedOperation = form.querySelector(
    'input[name="operation_type"]:checked'
  );

  if (selectedOperation) {
    selectedOperation.checked = false;
    resetMotorSelection();
    updateOperationType('');
    updateInstallationPrice();
    updateRunningTotal();
  }
}

if (currentStep < totalSteps) {
    showStep(currentStep + 1);
  }
});

backButton.addEventListener('click', () => {
  if (currentStep > 1) {
    showStep(currentStep - 1);
  }
});
progressItems.forEach((item) => {
  item.addEventListener('click', () => {
    if (isChoosingAnotherItem) {
  return;
  }
    const targetStep = Number(
      item.dataset.progressStep
    );

    if (!targetStep) {
      return;
    }

    const isAllowed =
      targetStep <= highestReachedStep;

    if (!isAllowed) {
      return;
    }

    showStep(targetStep);
  });
});
    form.addEventListener('input', (event) => {
      const field = event.target;

      setMessage();

    if (field === widthField) {
  validateMeasurementField(
    widthField,
    widthError,
    'Width'
  );
  updateMotorisedAvailability();
 }

      if (field === dropField) {
        validateMeasurementField(
          dropField,
          dropError,
          'Drop'
        );
      }
      if (
  field === widthField ||
  field === dropField
) {
  updateRunningTotal();
}
    });

    form.addEventListener('change', (event) => {
      const field = event.target;

      setMessage();

      if (field.name === 'blind_type') {
        populateCollections(field.value);
      }

     if (field.name === 'collection') {
  populateColours(field.value);
  updateRunningTotal();
}

    if (field.name === 'operation_type') {
  updateOperationType(field.value);

  if (field.value !== 'motorised') {
    resetMotorSelection();
  }

  updateInstallationPrice();
}

      if (field.name === 'power_type') {
        updatePowerType(field.value);
      }
      const runningTotalFields = new Set([
  'operation_type',
  'motor_brand',
  'power_type',
  'remote',
  'charger',
  'installation'
]);

if (runningTotalFields.has(field.name)) {
  queueMicrotask(() => {
    updateRunningTotal();
  });
}
    });

   if (finalQuoteSubmitButton) {
  finalQuoteSubmitButton.addEventListener('click', async () => {
    if (isFinalQuoteSubmitting) {
      return;
    }

    if (!quoteItems.length) {
  if (finalQuoteMessage) {
    finalQuoteMessage.textContent =
      'Please add at least one blind before submitting your quote.';
  }

  return;
}
   const requiredCustomerFields = [
  customerFirstName,
  customerLastName,
  customerPhone,
  customerEmail,
  customerAddress,
  customerSuburb,
  customerPostcode
];

    for (const field of requiredCustomerFields) {
      if (!field) {
        continue;
      }

      if (!String(field.value || '').trim()) {
       if (finalQuoteMessage) {
  finalQuoteMessage.textContent =
    'Please complete all required customer details before submitting your quote.';
}

        field.focus();
        return;
      }

      if (!field.checkValidity()) {
        if (finalQuoteMessage) {
  finalQuoteMessage.textContent =
    field.validationMessage ||
    'Please check your customer details before submitting your quote.';
}

        field.focus();
        return;
      }
    }

    const postcodeValue =
  String(customerPostcode?.value || '').trim();

const postcode =
  /^\d{4}$/.test(postcodeValue)
    ? Number(postcodeValue)
    : null;

const serviceRanges = [
  [3000, 3006],
  [3008, 3008],
  [3011, 3013],
  [3020, 3020],
  [3044, 3058],
  [3064, 3068],
  [3070, 3073],
  [3081, 3085],
  [3087, 3088],
  [3090, 3090],
  [3093, 3095],
  [3101, 3109],
  [3111, 3111],
  [3121, 3129],
  [3130, 3138],
  [3140, 3140],
  [3145, 3156],
  [3161, 3163],
  [3165, 3169],
  [3170, 3175],
  [3180, 3189],
  [3190, 3197]
];

const isServiceablePostcode =
  postcode &&
  serviceRanges.some((range) => {
    return (
      postcode >= range[0] &&
      postcode <= range[1]
    );
  });

if (!isServiceablePostcode) {
  if (finalQuoteMessage) {
    finalQuoteMessage.textContent =
      'Sorry, this postcode is outside our current service area. Please contact us if you would like us to check availability.';
  }

  customerPostcode?.focus();
  return;
}

const finalQuoteTotal = quoteItems.reduce(
  (sum, item) => {
    return sum +
      Number(item.itemTotalIncGst || 0);
  },
  0
);

if (!currentQuoteId) {
  currentQuoteId =
    globalThis.crypto?.randomUUID?.() ||
    `quote-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2)}`;
}

if (!currentSubmissionId) {
  currentSubmissionId =
    globalThis.crypto?.randomUUID?.() ||
    `sq-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2)}`;
}

const finalQuotePayload = {
  quoteId: currentQuoteId,
  submissionId: currentSubmissionId,
  customer: {
    firstName:
      String(customerFirstName?.value || '').trim(),

    lastName:
      String(customerLastName?.value || '').trim(),

    phone:
      String(customerPhone?.value || '').trim(),

    email:
      String(customerEmail?.value || '').trim(),

    address:
      String(customerAddress?.value || '').trim(),

    suburb:
      String(customerSuburb?.value || '').trim(),

    postcode:
      String(customerPostcode?.value || '').trim()
  },

  items: quoteItems,

  itemCount: quoteItems.length,

  quoteTotalIncGst: finalQuoteTotal,

  createdAt: new Date().toISOString()
};


   if (
  quoteEmailForm &&
  quoteEmailName &&
  quoteEmailEmail &&
  quoteEmailPhone &&
  quoteEmailAddress &&
  quoteEmailPostcode &&
  quoteEmailTotal &&
  quoteEmailDetails
) {
  quoteEmailName.value =
    `${finalQuotePayload.customer.firstName} ${finalQuotePayload.customer.lastName}`.trim();

  quoteEmailEmail.value =
    finalQuotePayload.customer.email;

  quoteEmailPhone.value =
    finalQuotePayload.customer.phone;

  quoteEmailAddress.value =
    finalQuotePayload.customer.address;

  quoteEmailPostcode.value =
    finalQuotePayload.customer.postcode;

  quoteEmailTotal.value =
    formatDisplayPrice(
      finalQuotePayload.quoteTotalIncGst
    );

  const quoteDetailsText = finalQuotePayload.items
  .map((item, index) => {
    const values = item.values || {};

    const blindType =
      formatLabel(values.blind_type || '');

    const collection =
      item.collectionName ||
      formatLabel(values.collection || '');

    const colour =
      item.colourName ||
      formatLabel(values.colour || '');

    const width =
      values.width || '';

    const drop =
      values.drop || '';

    const operation =
      formatLabel(values.operation_type || '');

    const installationValue =
      values.installation || '';

    const installation =
      installationValue === 'supply-installation'
        ? 'Supply & Installation'
        : installationValue === 'supply-only'
          ? 'Supply Only'
          : formatLabel(installationValue);

   const lines = [
  `BLIND ${index + 1}`,
  `Product: ${blindType} Roller Blind`,
  `Collection: ${collection}`,
  `Colour: ${colour}`,
  `Measurement: W ${width} mm × H ${drop} mm`,
  `Operation: ${operation}`,
  `Control Side: ${formatLabel(values.control_side || '')}`,
  `Fitting Type: ${formatLabel(values.fitting_type || '')}`,
  `Roll Direction: ${formatLabel(values.roll_direction || '')}`,
  `Bracket Colour: ${formatLabel(values.bracket_colour || '')}`,
  `Bottom Rail: ${[
    formatLabel(values.bottom_rail_shape || ''),
    formatLabel(values.bottom_rail_colour || '')
  ].filter(Boolean).join(' · ')}`,
  `Installation: ${installation}`,
  `Blind Total: ${formatDisplayPrice(
    item.itemTotalIncGst
  )}`
];

if (
  values.operation_type === 'chain' &&
  values.chain_colour
) {
  lines.push(
    `Chain Colour: ${formatLabel(
      values.chain_colour
    )}`
  );
}
      if (values.operation_type === 'motorised') {
  if (values.motor_brand) {
    lines.push(
      `Motor Brand: ${formatLabel(
        values.motor_brand
      )}`
    );
  }

  if (values.power_type) {
    lines.push(
      `Power Type: ${formatLabel(
        values.power_type
      )}`
    );
  }

   if (values.remote) {
    lines.push(
      `Remote: ${formatLabel(
        values.remote
      )}`
    );
  }

  if (values.charger) {
    lines.push(
      `Charger: ${formatLabel(
        values.charger
      )}`
    );
  }
}

    return lines.join('\n');
  })
  .join('\n\n');

quoteEmailDetails.value =
  quoteDetailsText;
       
}

isFinalQuoteSubmitting = true;
finalQuoteSubmitButton.disabled = true;

if (finalQuoteMessage) {
  finalQuoteMessage.textContent =
    'Submitting your quote...';
}

try {
  const backendResponse = await fetch(
   '/apps/smart-quote',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(finalQuotePayload)
    }
  );

  const backendResult =
    await backendResponse.json();
    console.log(
  'Smart Quote Draft Order response:',
  backendResult
);

  if (
    !backendResponse.ok ||
!backendResult?.success
) {
  throw new Error(
    backendResult?.error ||
    'Draft Order could not be created.'
  );
}
const checkoutUrl =
  backendResult?.draftOrder?.invoiceUrl;

if (!checkoutUrl) {
  throw new Error(
    'Checkout URL was not returned.'
  );
}

console.log(
  'Smart Quote checkout URL:',
  checkoutUrl
);
window.location.href = checkoutUrl;
return;

let successContainer = quoteSubmitSuccess;

if (!successContainer) {
  successContainer =
    document.createElement('div');

  successContainer.className =
    'smart-quote__submit-success';

  successContainer.dataset.quoteSubmitSuccess =
    '';

  successContainer.innerHTML = `
    <h3>✓ Quote submitted successfully</h3>
    <p>
      Thank you. We’ve received your quote and will be in touch shortly.
    </p>
  `;

  quoteEmailForm.appendChild(
    successContainer
  );
}
successContainer.hidden = false;
root
  .querySelectorAll(
    '[data-edit-blind], ' +
    '[data-remove-blind], ' +
    '[data-view-blind-details], ' +
    '[data-add-another-from-quote], ' +
    '[data-add-another-from-confirmation]'
  )
  .forEach((button) => {
    button.hidden = true;
  });
if (quoteView) {
  quoteView.hidden = false;
}

if (form) {
  form.hidden = true;
}

if (quoteProgress) {
  quoteProgress.hidden = true;
}

if (smartQuoteActions) {
  smartQuoteActions.hidden = true;
}
if (persistentQuote) {
  persistentQuote.hidden = true;
}


} catch (error) {
  console.error(
    'Smart Quote backend submit failed:',
    error
  );

  isFinalQuoteSubmitting = false;
  finalQuoteSubmitButton.disabled = false;

  if (finalQuoteMessage) {
    finalQuoteMessage.textContent =
      'We could not submit your quote. Please try again.';
  }
}

  });
}

    form.addEventListener('submit', (event) => {
  event.preventDefault();
 

  if (!validateCurrentStep()) {
    
    return;
  }

const requiredBlindFields = [
  form.elements.blind_type?.value,
  form.elements.collection?.value,
  form.elements.colour?.value,
  form.elements.width?.value,
  form.elements.drop?.value,
  form.elements.operation_type?.value
];

const hasMissingBlindFields =
  requiredBlindFields.some((value) => {
    return !String(value || '').trim();
  });
  const selectedOperationType =
  form.elements.operation_type?.value || '';

  if (!selectedOperationType) {
  setMessage(
    'Please select Chain or Motorised before continuing.'
  );

  showStep(4);

  return;
}

const selectedPowerType =
  String(
    form.elements.power_type?.value || ''
  ).trim();

const selectedRemote =
  String(
    form.elements.remote?.value || ''
  ).trim();

const selectedCharger =
  String(
    form.elements.charger?.value || ''
  ).trim();

const isBatteryMotor =
  selectedPowerType
    .toLowerCase()
    .includes('battery');

const hasMissingMotorFields =
  selectedOperationType === 'motorised' &&
  (
    !String(
      form.elements.motor_brand?.value || ''
    ).trim() ||
    !selectedPowerType ||
    !String(
      form.elements.motor_model?.value || ''
    ).trim() ||
    !selectedRemote ||
    (isBatteryMotor && !selectedCharger)
  );

if (hasMissingMotorFields) {
  setMessage(
    'Please complete all motor options before adding this blind to your quote.'
  );

  showStep(4);

  return;
}

const basePriceModel = findBasePrice();


if (
  hasMissingBlindFields ||
  !basePriceModel ||
  Number(basePriceModel.sellingPrice) <= 0
) {
  setMessage(
    'Please complete the fabric selection and measurements before adding this blind to your quote.'
  );

  return;
}

  buildSummary();

const savedBlind = saveCurrentBlind();

if (savedBlind) {
  if (addedToQuoteConfirmation) {
    addedToQuoteConfirmation.hidden = false;
  }

  if (smartQuoteActions) {
    smartQuoteActions.hidden = true;
  }

  backButton.hidden = true;
  backButton.style.display = 'none';

  submitButton.hidden = true;
  submitButton.style.display = 'none';

  setMessage('');
} else {
  setMessage(
    'The blind could not be added to the quote.'
  );
}

});
    updateOperationType(
      form.querySelector(
        'input[name="operation_type"]:checked'
      )?.value || ''
    );
    updateMotorisedAvailability();

    const selectedBlindType =
      form.querySelector(
        'input[name="blind_type"]:checked'
      )?.value;

    if (selectedBlindType) {
      populateCollections(selectedBlindType);
    }
if (quoteSubmitSuccess) {
  if (form) {
    form.hidden = true;
  }

  if (quoteProgress) {
    quoteProgress.hidden = true;
  }

  if (smartQuoteActions) {
    smartQuoteActions.hidden = true;
  }

  root
    .querySelectorAll(
      '.smart-quote__header, ' +
      '.smart-quote__quote-view-header, ' +
      '.smart-quote__quote-items-column, ' +
      '.smart-quote__quote-summary'
    )
    .forEach((element) => {
      element.hidden = true;
    });

  if (quoteView) {
    quoteView.hidden = false;
  }


  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
} else {
  showStep(1);
}

}

  function initialiseAllSmartQuotes(
    container = document
  ) {
    if (container.matches?.('[data-smart-quote]')) {
      initialiseSmartQuote(container);
    }

    container
      .querySelectorAll('[data-smart-quote]')
      .forEach(initialiseSmartQuote);
  }

  function startSmartQuote() {
    initialiseAllSmartQuotes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startSmartQuote
    );
  } else {
    startSmartQuote();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAllSmartQuotes(event.target);
    }
  );
})();